import React, { useContext } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, Button, Header } from 'semantic-ui-react';
import TextInput from '../../app/common/form/TextInput';
import { RootStoreContext } from '../../app/stores/rootStore';
import { ILoginRequest } from '../../app/models/shareholder';
import { FORM_ERROR } from 'final-form';
import { combineValidators, isRequired, createValidator, composeValidators } from 'revalidate';
import ErrorMessage from '../../app/common/form/ErrorMessage';
import { observer } from 'mobx-react-lite';

const isValidEmail = createValidator(
  message => value => {
    if (value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      return message
    }
  },
  'Invalid email address'
)

const validate = combineValidators({
  email: composeValidators(
    isRequired('Email'),
    isValidEmail
  )(),
});

const ForgotPasswordForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { forgot, errorMessage } = rootStore.shareholderStore;
  return (
    <FinalForm
      onSubmit={(email: string) =>
        forgot(email).catch(error => ({
          [FORM_ERROR]: error
        }))
      }
      validate={validate}
      render={({
        handleSubmit,
        submitting,
        submitError,
        invalid,
        pristine,
        dirtySinceLastSubmit
      }) => (
        <Form onSubmit={handleSubmit} error>
          <Header
            as='h2'
            content='Forgot Password'
            color='blue'
            textAlign='center'
          />
          <Field name='email' component={TextInput} placeholder='Email' />
          
          {submitError && !dirtySinceLastSubmit && (

            <ErrorMessage
              text={errorMessage}
              error={submitError}
            />
          )}
          <Button
            disabled={(invalid && !dirtySinceLastSubmit) || pristine}
            loading={submitting}
            primary
            content='Login'
            fluid
          />
        </Form>
      )}
    />
  );
};

export default observer(ForgotPasswordForm);
